module.exports = __webpack_public_path__ + "img/sand-rock-medium-05.1ba579f8.png";